import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";
import {
  IEditESignRule,
  IESignRule,
  INewESignRule,
  IESignRuleService,
  INewESignRuleService,
  IEditESignRuleService,
  IESignRuleDocument,
  INewESignRuleDocument,
  IEditESignRuleDocument,
  IESignAutomationVariable,
} from "../models/esign-rule";




const ESIGN_RULE_ROUTE = process.env.REACT_APP_4UESIGN + "/api/v1/ESignRule/";

export const getESignRuleById = (id: string) => {
  return GlobalAxios.get<IESignRule>(ESIGN_RULE_ROUTE + id);
};

export const createESignRule = (item: INewESignRule) => {
  return GlobalAxios.post(ESIGN_RULE_ROUTE, item);
};

export const updateESignRuleById = ({
  item,
  id,
}: {
  item: IEditESignRule;
  id: string;
}) => {
  return GlobalAxios.put(ESIGN_RULE_ROUTE + id, item);
};

export const eSignRuleList = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(ESIGN_RULE_ROUTE + "list", {
    params: params,
    paramsSerializer: { indexes: null },
  });
};




const ESIGN_RULE_SERVICE_ROUTE = process.env.REACT_APP_4UESIGN + "/api/v1/ESignRuleService/";

/**
 * Busca paginada de serviços.
 * @param params Deve conter { RuleId: string, PageNumber: number, ... }
 */
export const getESignRuleServicePaginated = (params: any) => {
  return GlobalAxios.get(ESIGN_RULE_SERVICE_ROUTE, {
    params: params,
    paramsSerializer: { indexes: null },
  });
};

export const getESignRuleServiceById = (id: string) => {
  return GlobalAxios.get<IESignRuleService>(ESIGN_RULE_SERVICE_ROUTE + id);
};

export const createESignRuleService = (item: INewESignRuleService) => {
  return GlobalAxios.post(ESIGN_RULE_SERVICE_ROUTE, item);
};

export const updateESignRuleServiceById = ({
  item,
  id,
}: {
  item: IEditESignRuleService;
  id: string;
}) => {
  return GlobalAxios.put(ESIGN_RULE_SERVICE_ROUTE + id, item);
};

export const deleteESignRuleServiceById = (id: string) => {
  return GlobalAxios.delete(ESIGN_RULE_SERVICE_ROUTE + id);
};




const ESIGN_RULE_DOCUMENT_ROUTE = process.env.REACT_APP_4UESIGN + "/api/v1/ESignRuleDocument/";

/**
 * Busca paginada de documentos.
 * @param params Deve conter { RuleId: string, PageNumber: number, ... }
 */
export const getESignRuleDocumentPaginated = (params: any) => {
  return GlobalAxios.get(ESIGN_RULE_DOCUMENT_ROUTE, {
    params: params,
    paramsSerializer: { indexes: null },
  });
};

export const getESignRuleDocumentById = (id: string) => {
  return GlobalAxios.get<IESignRuleDocument>(ESIGN_RULE_DOCUMENT_ROUTE + id);
};

export const createESignRuleDocument = (item: INewESignRuleDocument) => {
  return GlobalAxios.post(ESIGN_RULE_DOCUMENT_ROUTE, item);
};

export const updateESignRuleDocumentById = ({
  item,
  id,
}: {
  item: IEditESignRuleDocument;
  id: string;
}) => {
  return GlobalAxios.put(ESIGN_RULE_DOCUMENT_ROUTE + id, item);
};

export const deleteESignRuleDocumentById = (id: string) => {
  return GlobalAxios.delete(ESIGN_RULE_DOCUMENT_ROUTE + id);
};

const ESIGN_AUTOMATION_VARIABLES_ROUTE =
  process.env.REACT_APP_4UESIGN + "/api/v1/EsignAutomationVariables/";

export const getESignAutomationVariables = (params: {
  EsignAutomationId: string;
}) => {
  return GlobalAxios.get<IESignAutomationVariable[]>(
    ESIGN_AUTOMATION_VARIABLES_ROUTE + "list",
    {
      params: params,
      paramsSerializer: { indexes: null },
    },
  );
};
